import { Component } from "@angular/core";
import { ShareService } from '../../../services/share.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonfunctionService } from '../../../../services/commonfunction.service';


@Component({
    selector: 'toolbox-map',
    templateUrl: './toolbox.component.html',
    styleUrls: ['./toolbox.component.css']
  })
  export class ToolboxComponent {
    mobile: boolean = false;
    floors: any = [];
    parent: any;
    selected_floor: any;
    current_floor_info: any;
    addUnitAction: boolean = false;
    setActive: string = '';
    toggle: boolean = false;
    copied: any = '';
    flagVal: number = 0;
    constructor(public share: ShareService, private readonly fnc: CommonfunctionService, public dialog: MatDialog,
      private readonly route: Router) {
    }
  
    isActive(mode) {
      return (mode == this.setActive);
    }
  
    currentFloor(e) {
      this.parent.copied = null;
      this.parent.unitGisUids = [];
      this.parent.unitGisUidsForPaste = [];
      this.current_floor_info = {};
      let name = e.source.value;
      this.current_floor_info = this.fnc.getArrayValue('name', name, this.floors);
      this.parent.getUnitData();
  
      if (!this.mobile) {
        this.unitList(true);
      }
      this.parent.map.switchFloor(this.current_floor_info.gid);
    }
    unitList(flag = false) {
      this.flagVal = 1;
      this.parent.copied = null;
      if (this.mobile) {
        this.route.navigateByUrl('/unit');
      } else {
        if (!flag) {
          this.dialog.closeAll();
        }
        this.recallUnitApi();
      }
    }
    recallUnitApi() {
      setTimeout(() => {
      }, 200);
    }
    clear() {
      this.parent.unitGisUidsForPaste = [];
      this.parent.unitGisUids = [];
      this.parent.copied = null;
      this.parent.map.switchFloor(this.current_floor_info.gid);
      this.parent.copied = null;
    }
    copyUnit() {
      this.parent.copy();
    }
  
    drawPolygon(mode) {
      if(!this.setActive){
        this.toggle = true;
      }else if(this.setActive == mode){
          this.toggle = false;
        }else{
          this.toggle = true;
      }
    }
  
    openGroupDialog() {
      if (this.parent.unitGisUidsForPaste.length) {
        this.parent.openDialog();
      }
    }
  }